import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { chatStore } from '~/lib/stores/chat';

export const Logo = memo(() => {
  const chatStarted = useStore(chatStore.started);
  return (
    <a href="/" className="text-2xl font-semibold text-accent flex items-center">
      {chatStarted ? (
        <span className="i-bolt:logos-bolt?mask w-[46px] inline-block" />
      ) : (
        <span className="i-bolt:logos-bolt-new?mask w-[70.5px] inline-block" />
      )}
    </a>
  );
});

Logo.displayName = 'Logo';
